import React, { useContext, useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

//Notes for 8/26
//Create a new Menu component
//Connect this to Menu comp. (this function gives the selected dropdown item)
//Style the dropdown
//Make separate CSS for dropdown box for reuse

const MenuDropdown = () => {

    const { zipCode } = useContext(AuthContext); // Get zipCode from context
    const { countyName } = useContext(AuthContext); // Get countyName from context
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState("");
    
    const [isDropped, setIsDropped] = useState(""); 
    // const [isDropped, setIsDropped] = useState({ 

    //     Food: false,
    //     Education: false,
    //     Health: false,
    //     Housing: false,
    //     Legal: false,
    //     Money: false,
    //     More: false,
    //     Transit: false,
    //     Utilities: false,
    //     Work: false,
    // });

    const iconMap = {
        Food: 'Apple',
        Housing: 'House',
        Transit: 'Bus',
        Utilities: 'Utilities',
        Health: 'Healthcare',
        Money: 'Money',
        Education: 'Education',
        Work: 'Immigration',
        Legal: 'Legal',
        More: 'Abuse',
    };

    const options = [
        "Food Pantries", 
        "SNAP/Food Stamps/WIC", 
        "Hot Meals / Daily Meals", 
        "Nutrition Education", 
        "Formula",
        "Food for Seniors", 
        "Food for Families of Hospitalized Patients", 
        "Meals for K-12"
    ];

    const allOptions = {

        Food: [
            "Food Pantries", 
            "SNAP/Food Stamps/WIC", 
            "Hot Meals / Daily Meals", 
            "Nutrition Education", 
            "Formula",
            "Food for Seniors", 
            "Food for Families of Hospitalized Patients", 
            "Meals for K-12"
        ],
        Housing: [
            "Affordable Housing",
            "Shelters / Temporary Housing",
            "Rental Assistance",
            "Mortgage Assistance",
            "Foreclosure / Eviction Prevention",
            "Mold & Pests",
            "Home Maintenance",
            "Homeless Services"
        ],
        Transit: [
            "Medical Transport",
            "Financial Aid / Discounts",
            "Paratransit / Door-to-door Transit",
            "Medical Flights"
        ],

        Utilities: [
            "Internet & Phone",
            "Help with Utilities",
            "Air Conditioning/Heating",
        ],

        Health: [
            "Medicaid / Insurance",
            "Find a Provider",
            "Chronic Conditions / Disabilities",
            "Mental Health",
            "Medical Equipment (DME)",
            "Case Management",
            "Therapy",
            "Presciption Costs"
        ],

        Money: [
            "Financial Assistance", 
            "Government Benefits", 
            "Insurance Assistance"
        ],

        Education: [
            "Early Childhood Learning",
            "Scholarships (K-12)",
            "Support Children with Disabilities",
            "Camps & After School Programs",
        ],

        Work: [
            "Find a Job", 
            "Job Skills Training"
        ],
        Legal: [
            "Free Legal Assistance", 
            "Help with Legal Fees",
            "Guardianship",
            "Immigration Services"
        ],
        More: [
            "Case Managers",
            "Discounted Goods",
            "Other Help",
        ],
    }

    const toggleDropdown = (keyword) => {

        //if the dropdown button is open, it sets the isDropped value to null
        //if not, chnages it to the name of the new button
        if(isDropped == keyword){

            setIsDropped("");
        }else{

            setIsDropped(keyword);
        }
    };

    // const toggleDropdown = () => {
    //     setIsOpen(!isOpen);
    // };

    const handleSelect = (e, queryValue = '') => {

        // setSelected(option);
        // searchQueryCat = selected;
        // setIsOpen(false);
        e.preventDefault();
        const queryParams = new URLSearchParams();
        queryParams.append('keyword', queryValue);
        if (zipCode && !countyName) { // Include zipCode if available
            queryParams.append('zipCode', zipCode);
        }else if(!zipCode && countyName){ //Include the county name if available
            queryParams.append('countyName', countyName);
        }
        navigate(`/search-results?${queryParams.toString()}`);

        setSelected(queryValue);
    }; 

    // const handleSelect = (option) => {

    //     setSelected(option);
    //     searchQueryCat = selected;
    //     setIsOpen(false);
    // }; 

    return(
        <div style={{
                display: "flex",
                flexDirection: "column",
                // justifyContent: "center",
                justifyContent: "flex-start",
                alignItems:"center",
                marginTop: "10px", // just for spacing example
            }}
        >
            {Object.keys(iconMap).map((keyword) => (
                <div 
                    key={keyword} 
                    style={{ position: "relative", width: "100%", maxWidth: "500px"}}
                >

                    {/* Dropdown Button */}
                    <button 
                        onClick={() => toggleDropdown(keyword)} 
                        // onClick={toggleDropdown}
                        style={{ 
                            display: "flex",
                            width: "100%", 
                            padding: "8px 12px", 
                            backgroundColor: "#E3F5DA",
                            cursor: "pointer",
                            justifyContent: "flex-start",
                            // float: "right",
                        }}
                    >
                        <div style={{width: "20%"}}>
                            <img 
                                src={`/nemoursWhite${iconMap[keyword]}Icon.png`} 
                                tabindex="0"
                                width="50px"
                                height="50px"
                                style = {{
                                    verticalAlign: "middle", 
                                    outline: "none",
                                    // background: "#283618",
                                    // border: "none",
                                }}

                                alt={`${keyword} Icon`}
                            /> 
                        </div>

                        <div style={{width: "60%"}}>
                            <text style={{fontSize: "20px"}}>
                                {keyword}
                            </text>                            
                        </div>

                        <div style={{width: "20%"}}>
                            <text style={{fontSize: "20px"}}>
                                ▼
                            </text>                            
                        </div>                       

                    </button>

                    {/* Dropdown Menu */}
                    {/* {isOpen && ( */}
                    {(isDropped == keyword) && (
                        <ul
                        style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            margin: 0,
                            padding: "8px 0",
                            listStyle: "none",
                            background: "#FFF2D6",
                            border: "1px solid #ccc",
                            width: "100%",
                            zIndex: 1000,
                        }}
                        >
                            {Object.entries(allOptions).map(([category, options]) => 
                                category === isDropped ? (
                                <React.Fragment key={category}>

                                {/* {(category === isDropped) && */}

                                    { options.map((option, index) => (

                                        <li
                                        key={index}
                                        // onClick={() => handleSelect(option)}
                                        onClick={(e) => handleSelect(e, option)}
                                        style={{
                                            padding: "8px 12px",
                                            cursor: "pointer",
                                            background: selected === option ? "#B1D29B" : "#FFF2D6",
                                        }}
                                        >
                                            {option}
                                        </li>
                                     
                                    ))}
                                </React.Fragment>
                            ) : null )}
                        </ul>
                    )}           
                </div>
            ))}
        </div>
    );
};

export default MenuDropdown;